import React, { FC } from "react";
import { SVGProps } from '@utils';
import { SvgWrapper } from "./SvgWrapper";

interface CrossProps extends SVGProps {
  width?: number;
  height?: number;
}

export const Cross: FC<CrossProps> = ({ onClick, divClassName, width, height }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width={width ?? "12"} height={height ?? "13"} viewBox="0 0 12 13" fill="none">
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M0.378476 0.0707413C0.220714 0.149611 0.121417 0.261384 0.0541543 0.435858C-0.00945859 0.600729 -0.00955611 0.712855 0.0537308 0.878926C0.0887961 0.971035 0.859287 1.82911 2.63618 3.75499L5.16863 6.49979L2.62135 9.26245C-0.123453 12.2394 -0.0367352 12.1335 0.0165797 12.4414C0.0602157 12.6935 0.282959 12.9348 0.515608 12.982C0.799813 13.0398 0.702145 13.1337 3.44995 10.1603L6 7.40086L8.55005 10.1603C11.2979 13.1337 11.2002 13.0398 11.4844 12.982C11.717 12.9348 11.9398 12.6935 11.9834 12.4414C12.0367 12.1335 12.1235 12.2393 9.37875 9.26256L6.83156 6.5L9.37875 3.73744C12.1235 0.760657 12.0367 0.866464 11.9834 0.558576C11.9398 0.306538 11.717 0.0652337 11.4844 0.0179613C11.2002 -0.0397965 11.2979 -0.133741 8.54996 2.8398L5.9998 5.59935L3.46614 2.85586C1.6884 0.930894 0.89634 0.0961958 0.811317 0.0582084C0.653164 -0.0125413 0.538355 -0.00918757 0.378476 0.0707413Z" 
        fill="#5F6368"
      />
    </svg>
  </SvgWrapper>
)